export enum EFilterType{
    Text,
    TimeMin,
    TimeMax,
    Select,
    DateMin,
    DateMax
}